import React from 'react';
import ReactDOM from 'react-dom';
import SearchFormWrapper from './SearchFormWrapper';

const renderSearchForm = () => {
  let rendered = false;
  return () => {
    if (rendered) return;
    rendered = true;

    // Desktop react container
    const mountNodeDesktop = document.querySelector('[react-render-target="alo-search"]');

    if (mountNodeDesktop) ReactDOM.render(<SearchFormWrapper targetDevices={['desktop']} />, mountNodeDesktop);
    else console.warn('missing render target on desktop: SearchForm');
  };
};

export const initSearchForm = renderSearchForm();
